import './bikFishCtrl'
import './checkEmail'
import './bikPhotoCtrl'


// WEBPACK FOOTER //
// src/js/controllers/bikfish/index.js